module.exports = __webpack_public_path__ + "img/collection-weddingRingsCheap.38759df.jpg";